var spoiler_default = {
  "fontElementMap": "HKPF4",
  "hideText": "E5KkW",
  "onHoverText": "nQWnO",
  "hideBlock": "iMJAn",
  "smallBlur": "FyyKH",
  "mediumBlur": "OtLsL",
  "largeBlur": "WwsHc",
  "hideBlock_gallery": "TsuHh",
  "overlay": "YQJWv",
  "overlay_gallery": "d4dvl",
  "revealSpoilerBtn": "ZTao2",
  "isMobile": "BFniT",
  "onHoverBtn": "fXXLd",
  "spoilerWrapper": "b0JqY",
  "spoilerDescription": "MU9J-",
  "spoilerContainer": "fem38",
  "spoilerContainer_Gallery": "LJ5ei"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
